export default __webpack_public_path__ + "static/media/dashboard.19dba11f.svg";